import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'

export default function Ball(props) {
  const targetRef = useRef();
  const { nodes, materials } = useGLTF('/models/football_design_blue.glb')
  useGSAP(() => {
    gsap.to(targetRef.current.position,{
      y: targetRef.current.position.y + 3,
      duration: 0.6,
      repeat: -1,
      yoyo: true
    }
    )
  })
  return (
    <group ref={targetRef} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Hedra002_01_-_Default_0'].geometry}
        material={materials['01_-_Default']}
        position={[1.256, 0, -0.251]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
    </group>
  )
}

useGLTF.preload('/models/football_design_blue.glb')
